import { styled } from 'styled-components';

export const Container = styled.div<{ $hidden: boolean }>`
  display: flex;
  justify-content: center;
  color: var(--white);
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  padding: 0 24px;
  transition: opacity 1s;
  opacity: 1;
  z-index: 1400;
  pointer-events: none;

  ${({ $hidden }) =>
    $hidden &&
    `
        opacity: 0;
    `}
`;

export const Message = styled.div<{ $type: 'success' | 'error' | 'info' }>`
  padding: 12px 16px;
  border-radius: 8px;
  color: var(--white);
  background-color: ${({ $type }) => {
    switch ($type) {
      case 'success':
        return '#00a336';
      case 'error':
        return 'rgba(255, 0, 0, 0.7)';
      case 'info':
        return 'rgba(0, 0, 0, 0.7)';
      default:
        return 'var(--green-ribbon-500)';
    }
  }};
`;
